import { FormControl, FormGroup, ValidatorFn } from '@angular/forms';

export function matchingPasswords<K1 extends string, K2 extends string>(
  passwordKey: K1,
  passwordConfirmationKey: K2,
): ValidatorFn {
  return <T extends FormGroup<{ [k in K1 | K2]: FormControl<string> }>>(group: T) => {
    const password = group.controls[passwordKey];
    const passwordConfirmation = group.controls[passwordConfirmationKey];
    const isMismatch =
      password.value !== passwordConfirmation.value && passwordConfirmation.value && password.value;

    return isMismatch ? { mismatchedPasswords: true } : null;
  };
}
